/**
 * CAPTURE METHOD SELECTOR
 * 
 * Radio buttons for Manual / Polycam / Hover
 */

import React from 'react';
import { Ruler, Smartphone, Home } from 'lucide-react';

const CAPTURE_METHODS = [
  { 
    value: 'manual', 
    label: 'Manual Entry',
    icon: Ruler,
    description: 'Enter dimensions by hand',
  },
  { 
    value: 'polycam', 
    label: 'Polycam LiDAR',
    icon: Smartphone,
    description: 'Upload interior scan',
  },
  { 
    value: 'hover', 
    label: 'Hover (Exterior)',
    icon: Home,
    description: 'Upload property report',
  },
];

const CaptureMethodSelector = ({ value, onChange, disabled = false }) => {
  return (
    <div className="space-y-3">
      <label className="block text-sm text-slate-400">
        How are you capturing measurements?
      </label>
      
      <div className="grid grid-cols-3 gap-3">
        {CAPTURE_METHODS.map(method => {
          const Icon = method.icon;
          const isSelected = value === method.value;
          
          return (
            <button
              key={method.value}
              onClick={() => !disabled && onChange(method.value)}
              disabled={disabled}
              className={`
                p-4 border rounded text-left transition-all
                ${isSelected 
                  ? 'border-emerald-500 bg-emerald-500/10' 
                  : 'border-slate-700 bg-slate-800/50 hover:border-slate-600'
                }
                ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
              `}
            >
              <Icon className={`w-6 h-6 mb-2 ${isSelected ? 'text-emerald-400' : 'text-slate-400'}`} />
              <div className={`font-medium ${isSelected ? 'text-emerald-400' : 'text-slate-200'}`}>
                {method.label}
              </div>
              <div className="text-xs text-slate-500 mt-1">{method.description}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CaptureMethodSelector;
